"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M14.828 10.828a4 4 0 1 1-5.656-5.656 4 4 0 0 1 5.656 5.656Zm-1.414-1.414a2 2 0 1 1-2.828-2.828 2 2 0 0 1 2.828 2.828Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12Zm-2 0a9.953 9.953 0 0 1-1.536 5.328c-.386-1.199-1.182-2.248-2.217-3.066-1.552-1.227-3.695-1.987-6.055-2.05-2.361-.064-4.571.58-6.241 1.72-1.169.798-2.099 1.865-2.586 3.115A9.955 9.955 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10Zm-3.271 7.398Zm-.015-.231a.994.994 0 0 0 .015.231A9.962 9.962 0 0 1 12 22a9.968 9.968 0 0 1-7.057-2.915 1.01 1.01 0 0 0 .056-.285c.06-1.201.778-2.354 2.057-3.227 1.277-.873 3.058-1.417 5.037-1.364 1.979.053 3.701.69 4.89 1.63 1.188.939 1.791 2.128 1.731 3.328Z",
    clipRule: "evenodd"
  })]
});